// extracted by mini-css-extract-plugin
module.exports = {"panelToggle":"PanelToggle_panelToggle__zfoyd","expanded":"PanelToggle_expanded__WP5_M"};